import React from 'react';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { groupsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as groupsActions from 'actions/groupsActions';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { trackHaddockPlanningPublished } from 'utils/posthogTracking';


import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);

class GroupPublished extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let group = {
			name: '',
		}

		if (props.group) {
			group = props.group;
			if (props.group.calendar)
				group.calendar_id = props.group.calendar.id;

		}

		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			group,
			new_item_error: false,
		};
	}

	handleDateChange = (id, date) => {
		const { group } = this.state;
		let key = id;
		// Si la fecha es null (el usuario ha eliminado la fecha), establece el valor en null o en una cadena vacía
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			prevGroup: group,
			group: {
				...group,
				[key]: value,
			}
		});
	};


	checkValidField = (name) => {
		return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}

	handleSubmit = async event => {
		event.preventDefault();

		let response = '';
		const props = this.props;

		//console.log(this.state.group);
		const { group } = this.state;

		this.setState({ isLoading: true });

		response = await groupsService.update(group);

		//console.log(response);

		if (response.ok) {
			this.setState({
				isLoading: false,
				errors: {},
			}, () => {
				if (group.published_until) {
					trackHaddockPlanningPublished(this.props.user, {
						group_id: group.id,
						published_until: group.published_until,
					});
				}
				toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
				props.updateGroup(group);
				props.handleClose();
			});
		}
		else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response)
			});
		}

	}

	render() {
		const { group, errors } = this.state;

		return (

			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup controlId="published_until" className={`form-group form-date ${(group.published_until === '' || group.published_until === null) && 'empty'}  ${this.checkValidField('published_until') && "is-invalid"}`}>
						<FormLabel>{this.props.t('groups.form.publishedUntil')}</FormLabel>

						<DatePicker
							selected={group.published_until ? moment(group.published_until).toDate() : null}
							onChange={(date) => this.handleDateChange("published_until", date)}
							isInvalid={this.checkValidField("published_until")}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							locale="es"
							placeholderText="dd/mm/aaaa"
						/>

						<FiCalendar />
						<FormControl.Feedback type="invalid">
							{errors.published_until}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{this.props.t('common.cancel')}</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t('common.save')}
						loadingText={this.props.t('common.saving')}
					/>
				</div>
			</form>
		)
	}
}


const mapStateToProps = (reducers) => {
	return {
		...reducers.calendarsReducer,
		...reducers.groupsReducer,
		user: reducers.authReducer?.user,
	}
};

export default connect(mapStateToProps, groupsActions)(withTranslation()(GroupPublished))
